import axios from 'axios'
import { apiUrl } from '../utils/apiUrl'

const baseUrl = apiUrl('060082a935a915ae42231872311b0a08fcb1c252d15fb5d49673a53f16078dcc')
// const baseUrl = 'https://improve-bot.delightfulbush-65d4f852.westus3.azurecontainerapps.io/060082a935a915ae42231872311b0a08fcb1c252d15fb5d49673a53f16078dcc'

// const baseUrl = 'https://3af5-191-114-134-242.ngrok.io/060082a935a915ae42231872311b0a08fcb1c252d15fb5d49673a53f16078dcc'

export const login = async ({mail = '123', password = '123', tokenGoogle, tokenFacebook}) => {
  const response = await axios.post(baseUrl, {
    mail,
    password,
    tokenGoogle,
    tokenFacebook
  }) 
  return response

}